module.exports = __webpack_public_path__ + "media/98.989382ab.wav";